import React, { useState, useCallback } from 'react';
import CatagoryImage from './CatagoryImage';
import ImageViewer from 'react-simple-image-viewer';
import '../../css/Gallery.css'


function GalleryCatagory(props) {
    const { title, pics } = props

    let folder = "pro"
    function foundFolder() {
        switch (title) {
            case "Team and office":
                folder = "team"
                break

            case "Prospectus":
                folder = "pro"
                break

            case "Events":
                folder = "evt"
                break

            case "Carrier":
                folder = "car"
                break

            case "Achievements":
                folder = "ach"
                break

            case "Videos":
                folder = "evt"
                break

            case "Others":
                folder = "others"
                break

        }
    }
    foundFolder()

    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);

    const images = pics.map(img => `../../resource/gallery/${folder}/` + img);

    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };

    return (
        <>
            <div className="pt-5">
                <div className="d-flex flex-wrap justify-content-center  ">
                    {
                        pics.map((pic, index) => {

                            return <div className="col-md-3 rounded p-2 my-2 mx-4 img-div " style={{ minHeight: "200px" }} >
                                <div className="view overlay zoom w-100 h-100">
                                    <img
                                        src={require(`../../resource/gallery/${folder}/${pic}`)}
                                        onClick={() => openImageViewer(index)}
                                        width="300"
                                        key={index}
                                        style={{ margin: '2px' }}
                                        alt=""
                                        className="w-100 h-100"
                                    />
                                </div>
                            </div>
                        })
                    }
                    {isViewerOpen && (
                        <ImageViewer
                            src={images}
                            currentIndex={currentImage}
                            onClose={closeImageViewer}
                            disableScroll={false}
                            backgroundStyle={{
                                backgroundColor: "rgba(0,0,0,0.9)"
                            }}
                            closeOnClickOutside={true}
                        />
                    )}
                </div>
            </div>
        </>

    )
}

export default GalleryCatagory;
